import React from 'react';
import { Button, Icon, Modal } from 'semantic-ui-react';
import { ChildrenPropType } from '../../../../services/proptypes';
var defaultProps = {
  onBackButtonClick: null,
  show: false
};
export default function PublishModalContent(_ref) {
  var show = _ref.show,
    backButtonText = _ref.backButtonText,
    onBackButtonClick = _ref.onBackButtonClick,
    headerText = _ref.headerText,
    children = _ref.children;
  if (!show) return null;
  var backButtonStyle = onBackButtonClick ? {} : {
    cursor: 'inherit'
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    id: "domain-back-button",
    className: "back-button",
    onClick: onBackButtonClick,
    style: backButtonStyle
  }, onBackButtonClick && /*#__PURE__*/React.createElement(Icon, {
    name: "caret left"
  }), !onBackButtonClick && /*#__PURE__*/React.createElement(Icon, {
    name: ""
  }), backButtonText), /*#__PURE__*/React.createElement(Modal.Header, {
    className: "modal-header"
  }, headerText), /*#__PURE__*/React.createElement(Modal.Content, null, children));
}
PublishModalContent.defaultProps = defaultProps;